import * as actionCreatorFactory from "typescript-fsa";
import { Action } from "typescript-fsa";

import { StateError } from "@orm/models";
import { SearchResponse } from "../models";
import * as actionTypes from "../constants";

const actionCreator = actionCreatorFactory.default();

export const search = actionCreator<string>(actionTypes.SEARCH);

export const requestSearch = actionCreator<{}>(actionTypes.SEARCH_REQUEST);
export const searchSuccess = actionCreator<SearchResponse>(actionTypes.SEARCH_SUCCESS);
export const searchFailure = actionCreator<StateError>(actionTypes.SEARCH_FAILURE);

export type SearchAction = Action<string> | Action<{}> | Action<SearchResponse> |
    Action<StateError>;
